export const biddingStepsDefinitions = {
  0: { values: [200, 500, 1000, 2000, 3000, 5000], default: 1000 },
  100000: { values: [500, 1000, 2000, 3000, 4000, 6000], default: 1000 },
  200000: { values: [1000, 2000, 3000, 4000, 5000, 10000], default: 2000 },
  300000: { values: [1000, 2000, 3000, 4000, 5000, 10000], default: 3000 },
  400000: { values: [2000, 3000, 4000, 5000, 8000, 12000], default: 4000 },
  500000: { values: [2000, 3000, 5000, 7000, 10000, 15000], default: 5000 },
  600000: { values: [3000, 5000, 6000, 8000, 10000, 15000], default: 5000 },
  800000: { values: [4000, 5000, 8000, 10000, 15000, 20000], default: 5000 },
  1000000: { values: [5000, 7000, 10000, 15000, 20000, 25000], default: 10000 },
  1500000: {
    values: [5000, 10000, 15000, 20000, 25000, 30000],
    default: 10000,
  },
  2000000: {
    values: [5000, 10000, 15000, 20000, 30000, 40000],
    default: 15000,
  },
  3000000: {
    values: [10000, 15000, 20000, 30000, 40000, 50000],
    default: 20000,
  },
  5000000: {
    values: [10000, 20000, 30000, 40000, 50000, 100000],
    default: 30000,
  },
  10000000: { values: [30000, 50000, 70000, 100000, 150000], default: 50000 },
};



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/biddingStepsDefinitions.js